import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseAdvisorRuntime } from '../../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { DBDef_RuntimeActiveNavPathway } from '@app/advisor-shared';
import { ModuleFE_AdvisorSession } from '../../../advisor-session/index.js';
import { sendValidateCacheMessage } from '../../../../consts.js';
export const dispatch_onRuntimeActiveNavPathway = new ThunderDispatcherV3('__onRuntimeActiveNavPathwayUpdated');
export class ModuleFE_RuntimeActiveNavPathway_Class extends ModuleFE_BaseAdvisorRuntime {
    __validateCache() {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        const invalidActiveNavPathways = this.cache.filter(navPathway => navPathway.encounterId !== encounterId);
        const moduleName = this.getName();
        if (!invalidActiveNavPathways.length)
            return this.logDebug(`${moduleName} cache is valid`);
        this.logErrorBold(`${moduleName} has invalid data in cache`, invalidActiveNavPathways);
        return sendValidateCacheMessage(invalidActiveNavPathways, moduleName);
    }
    constructor() {
        super(DBDef_RuntimeActiveNavPathway, dispatch_onRuntimeActiveNavPathway);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
}
export const ModuleFE_RuntimeActiveNavPathway = new ModuleFE_RuntimeActiveNavPathway_Class();
//# sourceMappingURL=ModuleFE_RuntimeActiveNavPathway.js.map